import React from "react";
import { Icon, useModal } from "@clearabee/ui-library-native";
import { Pressable } from "react-native";
import { TooltipProps } from "./Tooltip.types";

export const Tooltip = ({
  children,
  styles: userStyles,
  icon = "Question",
  color = "warning",
  size = "medium",
}: TooltipProps) => {
  const [TooltipModal, showModal, isVisible] = useModal();
  const TooltipIcon = Icon[icon];

  return (
    <>
      <Pressable style={userStyles} onPress={() => showModal(!isVisible)}>
        <TooltipIcon color={color} size={size} />
      </Pressable>
      <TooltipModal onClose={() => showModal(!isVisible)}>
        {children}
      </TooltipModal>
    </>
  );
};
